import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { DeviceService } from '../../services/device.service';

@Component({
  selector: 'qwiko-dashboard-mobile-nav',
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './dashboard-mobile-nav.component.html',
  styleUrl: './dashboard-mobile-nav.component.scss',
})
export class DashboardMobileNavComponent {
  deviceService = inject(DeviceService);
}
